document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".header");
    header.classList.add("header--initialized");

    setTimeout(() => {
        const parentLinkElements = document.querySelectorAll(".header__inline-menu li.list-menu__item-parent");
        const childrenLinkElements = document.querySelectorAll(".mega-menu__list li");
        const topLevelLinks = Array.from(parentLinkElements)
            .map(parent => parent.querySelector(".header__menu-item a[href], a.header__menu-item[href]"))
            .filter(Boolean);
        const focusableSelector = "a[href], button:not([disabled]), input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";

        const mobileAccountLink = document.querySelector(".extra-item__link.header-account");
        const mobileAccountMenu = document.querySelector(".extra-item__link.header-account .account-dropdown");

        header.addEventListener("mouseleave", () => {
            closeMenu();
            toggleBodyScroll(true);
        });

        parentLinkElements.forEach((link) => {
            link.addEventListener("mouseenter", () =>{
                toggleBodyScroll(false);
                closeMenu();
                if(link.querySelector(".is-expended")) return;
                resetMenuToInitial(link);
                openMenu(link);
            });

            const topLevelLink = getTopLevelLink(link);
            const megaMenu = link.querySelector(".mega-menu");

            if (!topLevelLink) return;

            topLevelLink.addEventListener("focus", () => {
                closeMenu(link);

                if (megaMenu) {
                    resetMenuToInitial(link);
                    openMenu(link);
                    toggleBodyScroll(false);
                } else {
                    toggleBodyScroll(true);
                }
            });

            if (megaMenu) {
                topLevelLink.addEventListener("keydown", event => handleTopLevelKeydown(event, link));
                megaMenu.querySelector(".mega-menu__content")?.addEventListener("keydown", event => {
                    handleMegaMenuKeydown(event, link);
                });
            }

            link.addEventListener("focusout", () => {
                window.setTimeout(() => {
                    if (link.contains(document.activeElement)) return;

                    closeMenuItem(link);
                    if (!header.querySelector(".mega-menu[open]")) toggleBodyScroll(true);
                });
            });
        });


        childrenLinkElements.forEach(childrenLink => {
            childrenLink.addEventListener("mouseover", () => changeMenu(childrenLink));
            childrenLink.addEventListener("focusin", () => changeMenu(childrenLink));
        });

        mobileAccountLink?.addEventListener("click", toggleCustomerAccount);
        mobileAccountMenu?.addEventListener("click", (event) => event.stopPropagation());
    

        function resetMenuToInitial(parentLink) {
            const megaMenu = parentLink?.querySelector(".mega-menu");
            if (!megaMenu) return;

            const firstLinkedItem = megaMenu
                .querySelector(".mega-menu__link[data-mega-menu-target]")
                ?.closest("li");
            const firstItem = firstLinkedItem || megaMenu.querySelector(".mega-menu__list li");

            if (firstItem) changeMenu(firstItem);
        }

        function openMenu(link) {
            const tagDetails = link.querySelector(".mega-menu");
            if (!tagDetails) return;

            if (!tagDetails.hasAttribute("open")) {
                tagDetails.setAttribute("open", true);
            } 
            if (!tagDetails.classList.contains("is-expended")) {
                tagDetails.classList.add("is-expended");
            }

            getTopLevelLink(link)?.setAttribute("aria-expanded", "true");
        }

        function toggleBodyScroll(isScrollable) {
            document.body.style.overscrollBehavior = isScrollable ? '' : 'none';
            document.body.style.overflow = isScrollable ? 'auto' : 'hidden';
        }

        function closeMenu(linkToKeep = null) {
            parentLinkElements.forEach(link => {
                if (link === linkToKeep) return;
                closeMenuItem(link);
            });
            hideAllList();
            changeActiveStateMenu();
        }

        function closeMenuItem(link) {
            const details = link.querySelector(".mega-menu");
            if (!details) return;

            details.removeAttribute("open");
            details.classList.remove("is-expended");
            getTopLevelLink(link)?.setAttribute("aria-expanded", "false");
        }

        function getTopLevelLink(link) {
            return link.querySelector(".header__menu-item a[href], a.header__menu-item[href]");
        }

        function getVisibleFocusableElements(container) {
            return Array.from(container.querySelectorAll(focusableSelector)).filter(element => {
                const styles = window.getComputedStyle(element);
                return element.getClientRects().length > 0 &&
                    styles.visibility !== "hidden" &&
                    styles.display !== "none";
            });
        }

        function focusAdjacentToTopLevelLink(currentLink, direction) {
            const focusableElements = getVisibleFocusableElements(document);
            const currentIndex = focusableElements.indexOf(currentLink);
            const target = focusableElements[currentIndex + direction];

            target?.focus();
        }

        function handleTopLevelKeydown(event, parentLink) {
            const topLevelLink = getTopLevelLink(parentLink);
            const megaMenu = parentLink.querySelector(".mega-menu");

            if (!topLevelLink || !megaMenu) return;

            if (event.key === "ArrowDown") {
                event.preventDefault();
                resetMenuToInitial(parentLink);
                openMenu(parentLink);
                const firstMenuItem = getVisibleFocusableElements(
                    megaMenu.querySelector(".mega-menu__content")
                )[0];
                firstMenuItem?.focus();
                return;
            }

            if (event.key !== "Tab") return;

            event.preventDefault();
            closeMenuItem(parentLink);
            toggleBodyScroll(true);

            const currentIndex = topLevelLinks.indexOf(topLevelLink);
            const direction = event.shiftKey ? -1 : 1;
            const adjacentTopLevelLink = topLevelLinks[currentIndex + direction];

            if (adjacentTopLevelLink) {
                adjacentTopLevelLink.focus();
            } else {
                focusAdjacentToTopLevelLink(topLevelLink, direction);
            }
        }

        function handleMegaMenuKeydown(event, parentLink) {
            const megaMenu = parentLink.querySelector(".mega-menu");
            const topLevelLink = getTopLevelLink(parentLink);

            if (!megaMenu || !topLevelLink) return;

            if (event.key === "Escape") {
                event.preventDefault();
                topLevelLink.focus({ preventScroll: true });
                closeMenuItem(parentLink);
                toggleBodyScroll(true);
                return;
            }

            const focusedLevelTwoLink = event.target.closest(".mega-menu__link--level-2");
            if (focusedLevelTwoLink) {
                const levelTwoLinks = getVisibleFocusableElements(
                    megaMenu.querySelector(".mega-menu__list")
                ).filter(element => element.matches(".mega-menu__link--level-2"));
                const currentIndex = levelTwoLinks.indexOf(focusedLevelTwoLink);

                if (event.key === "ArrowRight" && focusedLevelTwoLink.dataset.megaMenuTarget) {
                    const targetPanel = document.getElementById(focusedLevelTwoLink.dataset.megaMenuTarget);
                    changeMenu(focusedLevelTwoLink.closest("li"));
                    const firstLevelThreeLink = targetPanel && getVisibleFocusableElements(targetPanel)[0];

                    if (firstLevelThreeLink) {
                        event.preventDefault();
                        firstLevelThreeLink.focus();
                    }
                    return;
                }

                if (["ArrowDown", "ArrowUp"].includes(event.key) && levelTwoLinks.length) {
                    event.preventDefault();
                    const direction = event.key === "ArrowDown" ? 1 : -1;
                    const nextIndex = (currentIndex + direction + levelTwoLinks.length) % levelTwoLinks.length;
                    levelTwoLinks[nextIndex].focus();
                    return;
                }

                if (event.key === "ArrowLeft") {
                    event.preventDefault();
                    topLevelLink.focus({ preventScroll: true });
                    return;
                }
            }

            const focusedSecondaryPanel = event.target.closest(".menu-secondary__list");
            if (focusedSecondaryPanel) {
                if (event.key === "ArrowLeft") {
                    const ownerLink = megaMenu.querySelector(
                        `.mega-menu__link[data-mega-menu-target="${focusedSecondaryPanel.id}"]`
                    );

                    if (ownerLink) {
                        event.preventDefault();
                        ownerLink.focus({ preventScroll: true });
                    }
                    return;
                }

                if (["ArrowDown", "ArrowUp", "ArrowRight"].includes(event.key)) {
                    const panelLinks = getVisibleFocusableElements(focusedSecondaryPanel);
                    if (!panelLinks.length) return;

                    const currentIndex = panelLinks.indexOf(document.activeElement);
                    const direction = event.key === "ArrowUp" ? -1 : 1;
                    const nextIndex = (currentIndex + direction + panelLinks.length) % panelLinks.length;

                    event.preventDefault();
                    panelLinks[nextIndex].focus();
                    return;
                }
            }

            const direction = ["ArrowDown", "ArrowRight"].includes(event.key)
                ? 1
                : ["ArrowUp", "ArrowLeft"].includes(event.key)
                    ? -1
                    : 0;

            if (!direction) return;

            const focusableElements = getVisibleFocusableElements(
                megaMenu.querySelector(".mega-menu__content")
            );
            const currentIndex = focusableElements.indexOf(document.activeElement);
            if (!focusableElements.length) return;

            const nextIndex = currentIndex === -1
                ? (direction === 1 ? 0 : focusableElements.length - 1)
                : (currentIndex + direction + focusableElements.length) % focusableElements.length;
            const nextElement = focusableElements[nextIndex];

            event.preventDefault();
            nextElement.focus();
        }

        function changeMenu(childrenLink) {
            const megaMenu = childrenLink.closest(".mega-menu");
            const levelTwoLink = childrenLink.querySelector(".mega-menu__link--level-2");
            if (!megaMenu || !levelTwoLink) return;

            hideAllList(megaMenu);
            changeActiveStateMenu(childrenLink, megaMenu);

            const targetId = levelTwoLink.dataset.megaMenuTarget;
            const targetPanel = targetId && document.getElementById(targetId);
            if (!targetPanel) return;

            targetPanel.classList.remove("menu-secondary__list--hide");
            targetPanel
                .querySelector(".popular-grid")
                ?.classList.remove("menu-popular__list-grid--hide");
        }

        function changeActiveStateMenu(activeLink = null, scope = document) {
            scope.querySelectorAll(".mega-menu__list li").forEach(childrenLink => {
                const levelTwoLink = childrenLink.querySelector(".mega-menu__link--level-2");
                const isActive = childrenLink === activeLink;

                childrenLink.classList.toggle("mega-menu__link--hover", isActive);
                levelTwoLink?.setAttribute("aria-expanded", isActive ? "true" : "false");
            });
        }

        function hideAllList(scope = document) {
            scope.querySelectorAll(".menu-secondary__list").forEach(grandChildren => {
                grandChildren.classList.add("menu-secondary__list--hide");
            });
            scope
                .querySelectorAll(".mega-menu__popular:not(.mega-menu__popular--full-width) .popular-grid")
                .forEach(popularProduct => {
                    popularProduct.classList.add("menu-popular__list-grid--hide");
                });
        }

        function toggleCustomerAccount() {
            if (!mobileAccountLink) return;
            const isMenuOpen = mobileAccountLink.classList.contains("header-account--show-menu");
            mobileAccountLink.classList.toggle("header-account--show-menu", !isMenuOpen)
        }

        const navigationButtons = document.querySelectorAll(".popular-navigation__button");
        navigationButtons.forEach((button,index,array) => button.addEventListener("click", () => {
            handleNavigationClick(button);
            updateStateButton(index,array);
        }));

        function handleNavigationClick(button) {
            const popularGrid = button.closest(".popular-grid");
            const collectionContainer = popularGrid?.querySelector(".popular-grid__wrapper");
            const template = findTemplate(button, popularGrid);
            if (!template) return;
            const { children } = template.content.cloneNode(true);
            if (children) {
                updateCollection(children, collectionContainer);
            }
        }

        function findTemplate(button, popularGrid)  {
            const templateId = button.dataset.templateId;
            return document.getElementById(templateId) || popularGrid?.querySelector("template[data-default-products]");
        }

        function updateCollection(children, container) {
            if (!container || !children.length) return;
            container.innerHTML = "";
            [...children].forEach(child => container.append(child));
        }

        function updateStateButton(index,arrayButton) {
            [...arrayButton].forEach( button => button.classList.remove("popular-navigation__button--active"));
            arrayButton[index].classList.add("popular-navigation__button--active");
        }
    }, 500)
});
